export default "__VITE_ASSET__bE8QYuFG__"